import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export interface DashboardFilters {
  created_at_from?: string;
  created_at_to?: string;
  createdBy?: string;
  user_id?: string;
}

export interface DashboardData {
  summary: {
    Total_Quotation: number;
    Total_by_status: {
      Lost: number;
      Draft: number;
      Sent: number;
    };
    given_sort_count: number;
    Won_count: number;
    Lost_count: number;
    Sent_count: number;
    Draft_count: number;
  };
  revenue: {
    Total_amount: number;
    Total_amount_currency: string;
  };
  quotation_breakdown: {
    BuildYourPCGroup: {
      Total: number;
      Won: number;
      Lost: number;
      Draft: number;
      Sent: number;
    };
    StandaloneGroup: {
      Total: number;
      Won: number;
      Lost: number;
      Draft: number;
      Sent: number;
    };
  };
  filters_used: {
    created_at_from: string;
    created_at_to: string;
    exclude_deleted: string;
  };
}

export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",
  async (filters: DashboardFilters, { rejectWithValue, dispatch }) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.created_at_from) {
        params.append("created_at_from", filters.created_at_from);
      }
      if (filters.created_at_to) {
        params.append("created_at_to", filters.created_at_to);
      }
      if (filters.createdBy) {
        params.append("created_by", filters.createdBy);
      }

      if (filters.user_id) {
        params.append("user_id", filters.user_id);
      }

      const response: any = await Axios.get(
        `/api/quotation/dashboard/?${params.toString()}`
      );

      // Check if user is inactive or deleted
      if (response?.data?.detail === "User inactive or deleted") {
        // Import logoutUser dynamically to avoid circular dependency
        const { logoutUser } = await import("../auth/login/thunk");
        await dispatch(logoutUser());
        return rejectWithValue("User inactive or deleted");
      }

      if (response?.data?.success) {
        return response.data.data;
      }
      
      return rejectWithValue("Failed to fetch dashboard data");
    } catch (err: any) {
      // Check if the error response indicates user is inactive or deleted
      if (err.response?.data?.detail === "User inactive or deleted") {
        // Import logoutUser dynamically to avoid circular dependency
        const { logoutUser } = await import("../auth/login/thunk");
        await dispatch(logoutUser());
        return rejectWithValue("User inactive or deleted");
      }
      return rejectWithValue(err.response?.data || "Failed to fetch dashboard data");
    }
  }
);
